<div class="trip-detail-popup-right">
  <img
    src="../../../assets/img/icons8-macos-close-60.png"
    class="close-icons"
    (click)="close()"
  />
</div>
<form [formGroup]="addNotesForm">
  <div class="accordion-class">
    <h5>Add Notes</h5>
    <mat-divider></mat-divider>
  </div>
  <div class="input-fileds-container">
    <div class="group">
      <div class="mtb w-100 pull-left">
        <mat-form-field class="flex-gt-sm example-full-width truck-type-input">
          <mat-datepicker-toggle matSuffix [for]="picker1">
          </mat-datepicker-toggle>
          <mat-datepicker #picker1></mat-datepicker>
          <input
            matInput
            formControlName="date"
            [matDatepicker]="picker1"
            placeholder="Pickup Date"
            [min]="minDate"
            (click)="picker1.open()"
          />
          <mat-error>Please select date</mat-error>
        </mat-form-field>
      </div>
      <div class="mtb w-100 pull-left">
        <mat-form-field>
          <mat-label>Employee Name:</mat-label>
          <input matInput formControlName="employee_name" required />
          <mat-error>Please Enter Employee Name</mat-error>
        </mat-form-field>
      </div>
      <div class="mtb w-100 pull-left">
        <mat-form-field>
          <mat-label>Notes:</mat-label>
          <input matInput formControlName="notes" required />
          <mat-error>Please Enter Notes</mat-error>
        </mat-form-field>
      </div>
    </div>
  </div>
  <button type="button" class="button buttonBlue" (click)="saveLog()">
    Save Log
  </button>
</form>
